function getChainId(): CHAIN_ID_TYPE {
    const chainId = parseInt(import.meta.env.VITE_CHAIN_ID as string)

    if (chainId !== GOERLI_CHAIN_ID && chainId !== MUMBAI_CHAIN_ID) {
        throw new Error('Invalid chain ID');
    }

    return chainId;
}


export const GOERLI_CHAIN_ID = 5
export const MUMBAI_CHAIN_ID = 80001
export type CHAIN_ID_TYPE = typeof GOERLI_CHAIN_ID | typeof MUMBAI_CHAIN_ID
export const CHAIN_ID: CHAIN_ID_TYPE = getChainId()
